import InfoBox from 'components/info-box';
import LoadingSpinner from 'components/loading-spinner';
import { useGet } from 'hooks/use-get';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { getCalibrationInformation } from 'views/bluviu-nutrition/features/calibrations/api/temperature-info';
import { CalibrationsParams } from 'views/bluviu-nutrition/features/calibrations/types/calibrations-params.type';
import ViewLocation from './temperature-location/view-location';
import ViewTemperatureProfile from './temperature-location/view-temperature-profile';
import { Box } from '@mui/material';

const TemperatureLocation: React.FC<{}> = ({}) => {
  const PAGE_NAME_ID = `bluViuNutrition.calibrations.editCalibration.temperatureLocation`;
  const params = useParams<CalibrationsParams>();

  const { data, isLoading } = useGet(['getTemperatureProfile', params.globalSiteId], ({ queryKey }) =>
    getCalibrationInformation(String(queryKey[1]))
  );

  if (isLoading) return <LoadingSpinner />;
  if (!data) return;

  return (
    <Box display={'flex'} flexDirection={'column'} gap={4}>
      <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} gap={4}>
        <ViewTemperatureProfile temperatureProfile={data.temperatureProfile} />
        {data.latitude != null && data.longitude != null && (
          <ViewLocation
            location={{
              latitude: data.latitude,
              longitude: data.longitude,
            }}
          />
        )}
      </Box>
      {!data.temperatureProfile?.length && (
        <InfoBox variant={'warning'}>
          <FormattedMessage id={`${PAGE_NAME_ID}.information`} />
        </InfoBox>
      )}
    </Box>
  );
};

export default React.memo(TemperatureLocation);
